module.exports = "\r\n\r\n    <div style=\"overflow:auto\">\r\n        <p-chart type=\"line\" [data]=\"data\" responsive=\"false\" [options]=\"options\"></p-chart>\r\n    </div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/graficas/chart/chart.component.html
// module id = ../../../../../src/app/componentes/graficas/chart/chart.component.html
// module chunks = main